{
  "bookmarkTitleLabel": "Segnalibri",
  "debug": "Debug",
  "devConnectionLabel": "Developer Connection",
  "exlSection": "Risultati da Experience League",
  "feedback": "Feedback",
  "fetchFailed": "Recupero non riuscito",
  "help": "Aiuto",
  "helpDefaultFeatured": "Formazione e supporto per Adobe Experience Cloud",
  "helpLoadError": "Qualcosa è andato storto. Riprova.",
  "noBookmarks": "Aggiungi i contenuti della guida ai segnalibri per accedervi qui",
  "noBookmarksTitle": "Nessun segnalibro",
  "noResults": "Nessun risultato",
  "noResultsMessage": "Verifica l’ortografia o prova a cercare un altro termine",
  "resourcesCustomerCareLabel": "Assistenza clienti",
  "resourcesStatusLabel": "Stato",
  "support": "Supporto"
}
